import localForage from 'localforage';
import pubsub from "@viewlift/pubsub"
import axios from 'axios';
import Cookies from 'js-cookie';
import { callRequest } from '../../../Graphql/request';
import { fetchUserData } from '../../../helpers';

export const AuthorisationStore = {
    "userdetails" : {},
  }

export const updateAuthorisationStore = async ({ userdetails }) => {
    try {
      AuthorisationStore.user = userdetails ? userdetails : AuthorisationStore.user;
  
      const res = await getUserData(AuthorisationStore.user.authorizationToken);
      AuthorisationStore.user = {
        ...AuthorisationStore.user,
        ...res
      };

      // Setting userState in cookies for personalized hompage modules rendered from servers side
      Cookies.set("userStateToken", JSON.stringify(res?.data?.userState))
  
      // Store the updated AuthorisationStore in IndexedDB using localForage
      await localForage.setItem('AuthenticationStore', AuthorisationStore);
  
      // After storing, get the updated store from IndexedDB and publish it using pubsub
      const updatedStore = await localForage.getItem('AuthenticationStore');
      pubsub.publish('AuthenticationStore', updatedStore);
  
      // Return the updated user object if needed
      return AuthorisationStore.user;
    } catch (err) {
      console.error('Error updating authorization store:', err);
      throw err; // Rethrow the error to handle it outside this function
    }
  };

const getUserData = (token) => {
  let site =  window?.app_data?.site?.siteInternalName
  let variables = {
    site
  }
  let cb = () => {}
  return fetchUserData()
};
